export default __webpack_public_path__ + "static/media/GreatWAll.cedcc13f.jpg";